import React from 'react';
import DevPanel from './index.tsx';
import type { Props } from './types.tsx';

const IssueViewDevPanel = ({ ...props }: Props) => <DevPanel {...props} />;

export default IssueViewDevPanel;
